import { SITE_ID } from './site-id';

/**
 * チェックインから予約詳細へ遷移する際のパラメータ
 * @param searchType　検索方法選択
 * @param orderId　予約番号
 * @param eTicketNumber 航空券番号
 * @param firstName　搭乗者名（名）
 * @param lastName 搭乗者名（姓）
 * @param SITE_ID 連携サイトID
 * @param nextAction 次に行うアクション
 * @param JourneyId JourneyID
 * @param flightIdList セグメントIDリスト
 * @param JSessionId セッションID
 * @param aswIntErrorId　国際ASWエラーID
 * @param errorId　エラーID
 * @param warningId　ワーニングID
 * @param travelers　搭乗者情報リスト
 * @param previousScreenId 予約詳細遷移元区分
 */
export interface ParameterToServicing {
  searchType?: 'order' | 'eTicket';
  orderId?: string;
  eTicketNumber?: string;
  firstName?: string;
  lastName?: string;
  SITE_ID?: keyof typeof SITE_ID;
  nextAction?: keyof typeof NEXT_ACTION;
  JourneyId?: string;
  flightIdList?: string[];
  JSessionId?: string | null;
  aswIntErrorId?: string;
  errorId?: string;
  warningId?: string;
  travelers?: string;
  previousScreenId?: string;
}

/**
 * 予約詳細画面にて、画面遷移後に行うことができるアクション
 * @param SERVICE 予約詳細(サービス)
 * @param EMAIL_ADDRESS_REGISTRATION メールアドレス登録
 * @param ACKNOWLEDGE　イレギュラー振替(Acknowledge)
 * @param SELF_REACCOMODATION イレギュラー振替(Self Reaccommodation)
 * @param TICKETING 発券
 * @param PAYMENT 払い込み
 * @param ONLINE_CHECKIN オンラインチェックイン
 * @param PASSENGER_INPUT 搭乗者情報入力
 * @param ETICKET_AND_EMD eチケット/EMD表示
 * @param UPGRADE アップグレード対象フライト選択画面
 * @param BAGGAGE_RULE 手荷物ルール
 * @param LOUNGE ラウンジ
 * @param FIRST_BAGGAGE ファーストバゲージ
 * @param MEAL 機内食
 * @param ADVANCED_SEAT_REQUEST 事前座席指定
 * @param YAMATO_BAGGAGE ヤマト手荷物
 * @param MY_CAR_VALET マイカーバレー
 * @param DUTY_FREE_PRE_ORDER 免税品プリオーダー
 */
export const NEXT_ACTION = {
  SERVICE: 'SERVICE',
  EMAIL_ADDRESS_REGISTRATION: 'EMAIL_ADDRESS_REGISTRATION',
  ACKNOWLEDGE: 'ACKNOWLEDGE',
  SELF_REACCOMODATION: 'SELF_REACCOMODATION',
  TICKETING: 'TICKETING',
  PAYMENT: 'PAYMENT',
  ONLINE_CHECKIN: 'ONLINE_CHECKIN',
  PASSENGER_INPUT: 'PASSENGER_INPUT',
  ETICKET_AND_EMD: 'ETICKET_AND_EMD',
  UPGRADE: 'UPGRADE',
  BAGGAGE_RULE: 'BAGGAGE_RULE',
  LOUNGE: 'LOUNGE',
  FIRST_BAGGAGE: 'FIRST_BAGGAGE',
  MEAL: 'MEAL',
  ADVANCED_SEAT_REQUEST: 'ADVANCED_SEAT_REQUEST',
  YAMATO_BAGGAGE: 'YAMATO_BAGGAGE',
  MY_CAR_VALET: 'MY_CAR_VALET',
  DUTY_FREE_PRE_ORDER: 'DUTY_FREE_PRE_ORDER',
} as const;
